export default () => ({
    configEmail: null,
    admins: null,
    config: null
})
